export default {
  common: {
    exception: '例外',
    warning: 'に警告'
  },
  inspection: {
    daysRemaining: '残りの日数',
    inspectionTableTitle: 'デバイス状態情報報告',
    companyExpiryTableTitle: 'エンタープライズ有効期限レポート'
  },
  alcoholDetectionRecord: {
    licesnePlateNo: 'ナンバープレート'
  },
  licensePlate: {
    num: 'ナンバープレート'
  },
  devicePermission: {
    '7': 'フィールド管理者'
  },
  device: {
    upgradeStatus: 'アップグレードステータス',
    view: '確認する',
    newFirmwave: '新しいファームウェア'
  },
  devicesCommand: {
    actionId: '操作者ID'
  },
  loginLog: {
    ip: 'IPアドレス'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/languages/ja/v2.js